import { z } from 'zod';

export const createForgotPasswordSchema = () =>
  z
    .object({
      phone: z.string().min(8, 'Enter a valid mobile number'),

      otp: z.string().regex(/^\d{6}$/, 'Enter the 6-digit code sent to your mobile'),

      newPassword: z
        .string()
        .min(1, 'password cannot be empty')
        .min(6, 'Minimum 6 characters required')
        .regex(/^[a-zA-Z0-9]+$/, 'Password can only contain letters and numbers (no special characters)'),

      confirmPassword: z.string().min(1, 'please confirm your password'),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
    });

export type ForgotPasswordFormValues = z.infer<ReturnType<typeof createForgotPasswordSchema>>;
